module.exports = __webpack_public_path__ + "static/img/5-2.02b8e5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/5-2.png
// module id = LUZR
// module chunks = 0